import { RefreshCw, AlertTriangle, XCircle, CircleDot } from "lucide-react";

// Design System 2.0 (2026-10, Phase 1 FIX PASS):
// - Only `fresh` renders nothing. An unknown/missing state renders a visible neutral pill
//   (restored — Phase 1 wrongly made `!STATE[state]` return null for ALL unrecognized states).
// - `stale` and `conflict` restored to their pre-Phase-1 colour severity: stale(red,
//   the more severe "failed" state) / conflict(gold, the lighter "needs a look" state) —
//   mapped onto the new 5-tone palette.
// - Label never contains the raw ISO timestamp — only a short relative time, or the state
//   word. The full value is tooltip-only, as before.
const STATE = {
  syncing: { icon: RefreshCw, cls: "text-tone-gold-text bg-tone-gold-bg njm-pulse", label: "Syncing", spin: true },
  stale: { icon: XCircle, cls: "text-tone-red-text bg-tone-red-bg", label: "Stale" },
  conflict: { icon: AlertTriangle, cls: "text-tone-gold-text bg-tone-gold-bg", label: "Sync conflict" },
};
const NEUTRAL = { icon: CircleDot, cls: "text-tone-grey-text bg-tone-grey-bg" };

function relativeTime(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const mins = Math.round((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.round(hrs / 24)}d ago`;
}

export function SyncPill({ state = "fresh", compact = false, lastSyncedAt, onRetry }) {
  if (state === "fresh") return null;
  const known = STATE[state];
  const s = known || NEUTRAL;
  const Icon = s.icon;
  const rel = state === "stale" && lastSyncedAt ? relativeTime(lastSyncedAt) : null;
  const label = rel ? `Synced ${rel}` : s.label || (state ? state.charAt(0).toUpperCase() + state.slice(1) : "Unknown");
  return (
    <span
      data-testid={`sync-pill-${state || "unknown"}`}
      title={lastSyncedAt ? `Last synced ${lastSyncedAt}` : undefined}
      className={`inline-flex items-center gap-1.5 rounded px-2 py-0.5 text-[11px] uppercase tracking-wider font-medium ${s.cls}`}
    >
      <Icon className={`h-3 w-3 ${s.spin ? "animate-spin" : ""}`} strokeWidth={2} />
      {!compact && <span>{label}</span>}
      {!compact && known && onRetry && (
        <button type="button" onClick={onRetry} data-testid={`sync-pill-${state}-retry`} className="underline">Retry</button>
      )}
    </span>
  );
}
